import {getShoppingSubscriptionResultInfo} from '@web/actions/result'
import {CashReceiptIssueType} from '@web/core/constants'
import makeSlice from '@web/slices/cashReceipt/sliceMaker'

import {fetchSubscription} from '../../actions'

const slice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(fetchSubscription.fulfilled, (state, {payload: {paymentMethodsResult}}) => {
                if (paymentMethodsResult?.cashReceipt?.issueNumber) {
                    const {
                        cashReceipt: {issueNumber, issueType, usageType},
                    } = paymentMethodsResult

                    state.issueType.saved = usageType
                    state.issueType.current = issueType

                    if (issueType === CashReceiptIssueType.BUSINESS_REGISTRATION_NUMBER) {
                        state.issueNumber.BUSINESS_REGISTRATION_NUMBER = [issueNumber]
                    } else if (issueType === CashReceiptIssueType.PR_CASH_RECEIPT_CARD_NUMBER) {
                        state.issueNumber.PR_CASH_RECEIPT_CARD_NUMBER = [issueNumber]
                    } else if (issueType === CashReceiptIssueType.PR_CELL_PHONE_NUMBER) {
                        state.issueNumber.PR_CELL_PHONE_NUMBER = [issueNumber]
                    }
                } else {
                    // cashReceipt slice의 기본 issueType이 전화번호로 되어있으므로, null로 초기화
                    state.issueType.current = null
                }
                state.shouldBeSaved = true
            })
            .addCase(getShoppingSubscriptionResultInfo.fulfilled, (state, {payload}) => {
                if (payload.paymentMethodsInfo.cashReceipt?.issueNumber) {
                    const {
                        cashReceipt: {issueNumber, issueType, usageType},
                    } = payload.paymentMethodsInfo

                    state.issueType.saved = usageType
                    state.issueType.current = issueType

                    if (issueType === CashReceiptIssueType.BUSINESS_REGISTRATION_NUMBER) {
                        state.issueNumber.BUSINESS_REGISTRATION_NUMBER = [issueNumber]
                    } else if (issueType === CashReceiptIssueType.PR_CASH_RECEIPT_CARD_NUMBER) {
                        state.issueNumber.PR_CASH_RECEIPT_CARD_NUMBER = [issueNumber]
                    } else if (issueType === CashReceiptIssueType.PR_CELL_PHONE_NUMBER) {
                        state.issueNumber.PR_CELL_PHONE_NUMBER = [issueNumber]
                    }
                } else {
                    // cashReceipt slice의 기본 issueType이 전화번호로 되어있으므로, null로 초기화
                    state.issueType.current = null
                }
                state.shouldBeSaved = true
            })
    },
})

export default slice.reducer
export const actions = slice.actions
